<template>
  <div class="excellences-carousel">
    <swiper-container init="false" class="excellences">
      <swiper-slide v-for="(slide, index) in slides" class="excellence">
        <div class="excellence-content">
          <p>{{ slide.text }}</p>

          <span class="line"></span>

          <div class="excellence-number">
            <p>{{ index + 1 }}<span>/{{ slides.length }}</span></p>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { register } from 'swiper/element/bundle';
register();

const props = defineProps({
  slides: {
    type: Array,
    required: true,
    default: []
  }
});

const swiperParams = {
  // freeMode: {
  //   enabled: true,
  //   sticky: true,
  // },
  navigation: {
    nextEl: '.carousel-button-next',
    prevEl: '.carousel-button-prev',
  },
  centeredSlides: true,
  allowTouchMove: false,
  // grabCursor: true,
  slideToClickedSlide: true,
  // autoplay: {
  //   delay: 3000,
  // },
  slidesPerView: 'auto',
  speed: 1500,
};

onMounted(() => {
  const swiperEl = document.querySelector('swiper-container');
  Object.assign(swiperEl, swiperParams);
  swiperEl.initialize();
});

////////////////////////////////////////////////////////////////// Move background image with mouse
import { devices, viewportSize } from './imports/utils.js';
const isDevice = devices();
import { gsap } from 'gsap';

const onMoveCursor = (e) => {
  const depth = 30;
  const moveX = ((e.pageX) - (window.innerWidth / 2)) / depth;

  gsap.to(".excellences-wrapper .excellences-bg-wrapper .excellences-bg", {
    duration: 2,
    x: moveX,
    ease: "slow",
    overwrite: true
  });
};

if (!isDevice) {
  document.addEventListener("mousemove", onMoveCursor, {
    passive: true,
  });
}

</script>

<style lang="scss"></style>